import { Button, Modal, ModalBody } from "flowbite-react";
import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { TermsContent, exportTermsToPdf } from "./ModalTerms";

export function ModalContract({ isOpen, onClose }) {
  const [isExporting, setIsExporting] = useState(false);
  const contractRef = useRef(null);

  const handleExportPdf = async () => {
    try {
      setIsExporting(true);
      await exportTermsToPdf(contractRef.current, "termos-de-uso.pdf");
    } catch (error) {
      console.error("Erro ao exportar os termos em PDF:", error);
      toast.error("Não foi possível exportar o PDF. Tente novamente.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Modal show={isOpen} onClose={onClose} size="5xl">
      <ModalBody className="p-0">
        <div
          ref={contractRef}
          data-terms-scroll-container
          className="max-h-[70vh] overflow-y-auto bg-slate-100/60 p-4"
        >
          <div className="mx-auto max-w-3xl rounded-lg border border-slate-200 bg-white shadow-sm">
            <TermsContent />
          </div>
        </div>
      </ModalBody>
      <Modal.Footer className="flex justify-center pt-2 pb-3">
        <Button
          color="light"
          onClick={handleExportPdf}
          disabled={isExporting}
          isProcessing={isExporting}
        >
          Exportar PDF
        </Button>
        <Button onClick={onClose}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
}
